export default __webpack_public_path__ + "static/media/fb.cdde1a35.svg";